import { OutputViewModel } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/viewModels/OutputViewModel';
export class CommonStateViewModel {
    static $inject = ['init'];
    constructor(init) {
        this.$contentActions = [];
        this.$conditionOutputs = [];
        this.$enteringCustomActions = [];
        this.$leavingCustomActions = [];
        this.$inputSuggestions = [];
        this.$defaultOutput = new OutputViewModel({ stateId: 'fallback' });
        this.$localCustomActions = [];
        Object.assign(this, init);
    }
}
